module.exports = __webpack_public_path__ + "img/bae.e31333f5.png";